import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';

export default function Hero({ t }) {
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setEntered(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <section
      id="top"
      className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background"
    >
      {/* Poster image for instant first paint, video plays over it once loaded */}
      <div className="absolute inset-0">
        <img
          src="/hero-poster.jpg"
          alt=""
          aria-hidden="true"
          fetchpriority="high"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <video
          data-testid="hero-background-video"
          src="/hero-diriyah.mp4"
          poster="/hero-poster.jpg"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          aria-label="Diriyah heritage landscape"
          className="absolute inset-0 h-full w-full object-cover"
        />
        {/* Cinematic overlays */}
        <div className="absolute inset-0 bg-gradient-to-b from-background/70 via-background/50 to-background" />
        <div className="absolute inset-0 bg-gradient-to-r from-background/60 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 text-center">
        <div
          style={{
            opacity: entered ? 1 : 0,
            transform: entered ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 0.9s ease-out, transform 0.9s ease-out',
          }}
        >
          <div className="mb-6 gold-divider mx-auto w-24" />
          <h1
            data-testid="hero-title"
            className="font-arabic text-5xl font-bold leading-[1.6] pb-2 text-primary md:text-7xl lg:text-8xl"
          >
            {t.hero.title}
          </h1>
          <div className="mt-6 gold-divider mx-auto w-24" />
        </div>

        <p
          data-testid="hero-subtitle"
          className="mx-auto mt-8 max-w-2xl text-lg text-foreground/70 md:text-xl"
          style={{
            opacity: entered ? 1 : 0,
            transform: entered ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 1s ease-out 0.2s, transform 1s ease-out 0.2s',
          }}
        >
          {t.hero.subtitle}
        </p>

        <div
          className="mt-16"
          style={{
            opacity: entered ? 1 : 0,
            transition: 'opacity 1s ease-out 0.5s',
          }}
        >
          <a
            href="#story"
            data-testid="hero-cta-link"
            className="inline-flex flex-col items-center gap-2 text-sm text-primary/70 transition-colors hover:text-primary"
          >
            {t.hero.cta}
            <ChevronDown className="h-5 w-5 animate-float" />
          </a>
        </div>
      </div>
    </section>
  );
}
